module.exports = __webpack_public_path__ + "src/assets/img/2_7art_2part_2gallery.248f9db5.jpg";